import React from 'react';
import {Col} from 'react-grid-system';
import {Drawable} from "../../../../../res/images/Drawable";

interface States {

}

interface Props {
}

class IosLogo extends React.Component<Props, States> {

    state: States

    constructor(props: Props) {
        super(props)
        this.state = {}

    }

    render() {
        return (
            <Col
                className="imageContainer"
                lg={6}>
                <img
                    className="iosLogo"
                    src={Drawable.iOSLogo}/>
            </Col>
        )
    }
}

export default IosLogo;
